"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Cell = require("../../cell/Cell.styled");
var _react = _interopRequireWildcard(require("react"));
var _Icon = require("../../../../media/icon/Icon");
var _jsxRuntime = require("react/jsx-runtime");
var SortableHeaderCell = function SortableHeaderCell(_ref) {
  var align = _ref.align,
    column = _ref.column,
    children = _ref.children,
    onSortChange = _ref.onSortChange;
  var _ref2 = (0, _react.useState)(column.getIsSorted()),
    _ref3 = _slicedToArray(_ref2, 2),
    sort = _ref3[0],
    setSort = _ref3[1];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Cell.StyledCell, {
    align: align,
    sortable: true,
    onClick: function onClick() {
      column.toggleSorting(sort === 'asc');
      var newSort = sort === 'asc' ? 'desc' : 'asc';
      setSort(newSort);
      if (onSortChange) {
        onSortChange(newSort, column.id);
      }
    },
    children: [children, column.getIsSorted() === false && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'sort'
    }), column.getIsSorted() === 'asc' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'arrowUp'
    }), column.getIsSorted() === 'desc' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'arrowDown'
    })]
  });
};
var _default = exports.default = SortableHeaderCell;